import React, {useContext} from "react";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {Box, Colors} from "@bounce/shared/ui";
import {DndEnabledContext, RowHandleContext} from "./SortableRowContext";

export const DragHandleCell = () => {
  const enabled = useContext(DndEnabledContext);
  const handle = useContext(RowHandleContext);
  if (!enabled || !handle) return null;

  return (
    <Box
      {...handle.attributes}
      {...handle.listeners}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      sx={{
        cursor: "grab",
        display: "flex",
        alignItems: "center",
        color: Colors.grey._400,
        "&:hover": {color: Colors.grey._700},
        "&:active": {cursor: "grabbing"},
      }}
    >
      <DragIndicatorIcon sx={{fontSize: 20}} />
    </Box>
  );
};
